import Menu from '@netx/core/lib/netx-menu';
import Menus from 'netxcore@netx/core-app/menus';

import {DOWNLOAD_REQUEST_EVENT} from '@netx/core-download-request/actions';

Object.assign(Menus, {
	sidebar: new Menu({
		actions: [
			'nx:home',
			'nx:folders',
			'nx:searches',
			'nx:collections',
			'nx:notifications',
		],
	}),
	tools: new Menu({
		actions: [
			DOWNLOAD_REQUEST_EVENT.LIST_ROUTE,
			'asset:requests:route',
			'upload:attributeData',
			'dataSet:dataSets:route',
			'asset:expirations:route',
			'share:tokens:route',
			'projects:route',
			'upload:bulkCartLoader',
			'stat:route',
		],
	}),
	user: new Menu({
		actions: [
			'user:profile:route',
			'user:settings:route',
			'user:attributeSets:route',
			'nx:notifications',
			'user:integrations:route',
			'app:help',
			'app:contact',
			['app:logout'],
		],
	}),
});

export default Menus;
